import { useState } from 'react';

export type ModalType =
  | 'sizing'
  | 'membership'
  | 'warranty'
  | 'outOfStock'
  | null;

export default function useModalState() {
  const [activeModal, setActiveModalType] = useState<ModalType>(null);

  const openModal = (type: ModalType) => {
    setActiveModalType(type);
  };

  const closeModal = () => {
    setActiveModalType(null);
  };

  return {
    activeModal,
    openModal,
    closeModal,
  };
}
